import '../sass/old_dcuk.scss';
import '../sass/spotlight-styles.scss';
import '../sass/sass.scss';
import '../sass/kirki-framework.scss';
import ScriptX from './scriptx';
import './functions.js';

import {createApp} from 'vue';
const vue = createApp({});

vue.use(ScriptX);

vue.config.globalProperties.$app = dcuk;

vue.component('weekly-subscribe', require('./components/weekly-subscribe').default);
vue.component('newsletter-subscribe', require('./components/newsletter-subscribe').default);

vue.mount('#app');